import {Component, OnInit, ViewChild} from '@angular/core';
import {QuestionnaireService} from '../../../../services/questionnaire.service';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {IBDDiskResults} from '../../../../model/questionnaires/questionnaire-ibddisk';
import {MatDialog} from '@angular/material/dialog';
import {ErrorDialogComponent} from '../../../user-actions/error-dialog/error-dialog.component';
import {BaseChartDirective} from 'ng2-charts';
import {ActivatedRoute, Router} from '@angular/router';
import { GradimentoResults, Q_GRADIMENTO } from 'src/app/model/questionnaires/questionnaire-gradimento';


@Component({
  selector: 'app-questionnaire-gradimento',
  templateUrl: './questionnaire-gradimento.component.html',
  styleUrls: ['./questionnaire-gradimento.component.css']
})
export class QuestionnaireGradimentoComponent implements OnInit {
  toShow: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0];  // forse da impostare a -1

  resultToSend: GradimentoResults;


  qForm: FormGroup;
  dataSource = Q_GRADIMENTO;
  displayedColumns = ['position', 'question', 'value'];
  notFocused = false;
  completed = false;
  private found = false;
  submitted = false;
  show = false;

  /// toolbar
  back = true;
  destination = '/landing';
  title = 'Questionario di gradimento';
  user = null;
  uuid = null;
  authorization: boolean;
  already_done= false;
  doctorID: string;
  patientSSN: string;
  sliderValue: number[] = [0];
  box_suggerimenti: string = "";
  window: any;

  constructor(private questionnaireService: QuestionnaireService,
              private route: ActivatedRoute,
              public dialog: MatDialog,
              private router: Router) {
  }

  ngOnInit(): void {

    this.user = JSON.parse(localStorage.getItem('user'));

    this.route.params.subscribe(params => {
      this.patientSSN = params.patientSSN;
      console.log("AUTH");
      console.log(this.user.ssn);
      console.log(params.patientSSN);
      this.questionnaireService.checkCompiledGradimento(this.patientSSN).subscribe( res => this.already_done=res );
      this.authorization = this.user.ssn.localeCompare(params.patientSSN) === 0;
      if (params.back.localeCompare('questionnaires') === 0) {
        this.destination = 'questionnaires';
      } else if (params.back.localeCompare('choose-questionnaire') === 0) {
        this.destination = 'choose-questionnaire';
      }
    });
    this.qForm = new FormGroup({
      boxSuggerimenti: new FormControl(''),
    });
    this.window = window;

  }

  selectResult(position: number) {
    if(position===10)
    { 
      this.box_suggerimenti = this.qForm.get("boxSuggerimenti").value;
    }
else {
    this.toShow[position - 1] = this.sliderValue[position - 1];
    console.log('SHOW: ' + this.toShow);
  } }


  onSubmit() {
    this.submitted = true;
    this.show = true;
    this.found = false;

    const sorted = [];

    sorted.push(...this.toShow);

    sorted.sort();


    for (const s of sorted) {
      if (s === -1) {  // TODO: forse da impostare a -1
        const msg = 'Non hai finito di completare il questionario!';
        this.openDialog(msg);
        this.found = true;
        this.show = false;
        this.submitted = false;
        break;
      }
    }

    if (!this.found) {
      this.resultToSend = new GradimentoResults(this.patientSSN,this.box_suggerimenti,this.toShow);
      console.log(this.resultToSend);
      this.questionnaireService.sendFormGradimento(this.resultToSend, 'gradimento');

    }
  }

  openDialog(message: string): void {
    const dialogRef = this.dialog.open(ErrorDialogComponent, {
      width: '500px',
      height: '270px',
      data: message
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Finestra chiusa');
    });
  }

  goHome() {
    if (this.user === null) {
      this.router.navigateByUrl('/startup');
    } else {
      this.router.navigateByUrl('/landing');
    }
  }
}